import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCode = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 6c0-1.655 1.345-3 3-3h18c1.655 0 3 1.345 3 3v12c0 1.655-1.345 3-3 3H3c-1.655 0-3-1.345-3-3zm13.828 1.453a1.12 1.12 0 0 0 0 1.59l2.953 2.952-2.953 2.953a1.125 1.125 0 0 0 1.59 1.59l3.75-3.75a1.12 1.12 0 0 0 0-1.59l-3.75-3.75a1.12 1.12 0 0 0-1.59 0zm-3.656 1.594a1.125 1.125 0 0 0-1.59-1.59l-3.75 3.75a1.12 1.12 0 0 0 0 1.59l3.75 3.75a1.125 1.125 0 0 0 1.59-1.59l-2.953-2.952 2.953-2.953z",
		fill: "#A6A3A1"
	})
});
export default SvgIconCode;
